export var AccountStatus;
(function (AccountStatus) {
    AccountStatus["PendingAuthorization"] = "PENDING_AUTHORIZATION";
    AccountStatus["PendingSetup"] = "PENDING_SETUP";
    AccountStatus["TestingLimits"] = "TESTING_LIMITS";
    AccountStatus["Pending"] = "PENDING";
    AccountStatus["Active"] = "ACTIVE";
    AccountStatus["Paused"] = "PAUSED";
    AccountStatus["Error"] = "ERROR";
})(AccountStatus || (AccountStatus = {}));
export var ExecutorStatus;
(function (ExecutorStatus) {
    ExecutorStatus["Pending"] = "pending";
    ExecutorStatus["Running"] = "running";
    ExecutorStatus["Error"] = "error";
})(ExecutorStatus || (ExecutorStatus = {}));
export function isAWSAccount(account) {
    return account.type == "AWS";
}
export function isAzureAccount(account) {
    return account.type == "AZURE";
}
export function isGCPAccount(account) {
    return account.type == "GCP";
}
